@if (showModal) {
<app-dialog-title>{{ "generate-package" | transloco }}</app-dialog-title>
<mat-dialog-content class="content">
  @if (errorMessage) {
  <p class="error-message">{{ errorMessage }}</p>
  } @if (bulkActionState !== 'COMPLETED') {
  <div>
    <p>
      {{ 'are-you-sure-you-want-to-generate-package-for-the-population-and-selected-tax-return-alias-s' | transloco: {taxReturnAlias} }}
    </p>
  </div>
  } @if (bulkActionState === 'COMPLETED') {
  <div>
    <p>
      {{
        "bulk-generate-package-process-has-been-started-this-may-take-a-while-we-will-update-you-on-the-progress"
          | transloco
      }}
    </p>
    <p>
      {{
        "the-generate-package-and-download-package-buttons-are-disabled-during-the-process-they-will-be-re-enabled-once-package-generation-is-finished"
          | transloco
      }}
    </p>
  </div>
  }
</mat-dialog-content>
@if (bulkActionState !== 'COMPLETED') {
<mat-dialog-actions align="end">
  <a class="go-back cancel" (click)="onClose()">{{ "cancel" | transloco }}</a>
  <button
    class="ui primary button"
    (click)="bulkGenerate()"
    [disabled]="submitButtonDisabled"
    [ngClass]="{ loading: bulkActionState === 'LOADING' }"
  >
    {{ "generate-package" | transloco }}
  </button>
</mat-dialog-actions>
} @if (bulkActionState === 'COMPLETED') {
<mat-dialog-actions align="end">
  <button class="ui primary button" (click)="onClose(true)">
    {{ "ok" | transloco }}
  </button>
</mat-dialog-actions>
} }
